import { render, staticRenderFns } from "./ImagenesList.vue?vue&type=template&id=1f4d4b1e"
import script from "./ImagenesList.vue?vue&type=script&lang=js"
export * from "./ImagenesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports